import { styled, ToggleButton } from '@mui/material';

export const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  color: theme.palette.text.primary,
  height: '40px',
  width: '88px',
  padding: '6px',
}));
